import React from 'react';
import { useCarousel } from '../common/landingHooks';

const ChevronL = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6" /></svg>;
const ChevronR = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6" /></svg>;

const QUOTES = [
    { q: 'It automates the routine groundwork so my team spends their time on advice, not admin. Our service margins have genuinely improved.', a: '— Partner, mid-tier accountancy firm' },
    { q: 'Being able to offer clients a structured route to investment and exit readiness has opened a new, high-margin revenue stream for the practice.', a: '— Director, advisory & corporate finance' },
    { q: 'Clients see the value immediately — a clear picture of where they stand and what to fix. It has made us far stickier as their adviser.', a: '— Managing Partner, regional firm' },
    { q: 'Free to us, valuable to the client. The introductions to new clients through the platform are a welcome bonus.', a: '— Founder, boutique accountancy practice' },
    { q: 'The AI does about 60% of the heavy lifting and we sign off the rest. It is the efficiency gain we have been looking for.', a: '— Client Services Lead, accountancy group' },
];

const GLOWS = [
    { top: -110, left: -90, size: 480, c: 'rgba(252,119,133,0.42)' },
    { top: 20, right: -120, size: 540, c: 'rgba(74,103,255,0.40)' },
    { bottom: -150, left: '12%', size: 520, c: 'rgba(74,103,255,0.34)' },
    { bottom: -110, right: '6%', size: 420, c: 'rgba(252,119,133,0.32)' },
];

const pos = (v) => (v == null ? 'auto' : typeof v === 'number' ? v + 'px' : v);

const AccountantsQuotesSection = () => {
    const { viewportRef, trackRef, page, pages, next, prev, goTo, pause, resume } = useCarousel(QUOTES.length, { autoplayMs: 5500 });

    return (
        <section className="lp-quotes">
            <div className="lp-quotes-bg" aria-hidden="true">
                {GLOWS.map((g, i) => (
                    <i key={i} style={{ top: pos(g.top), bottom: pos(g.bottom), left: pos(g.left), right: pos(g.right), width: g.size + 'px', height: g.size + 'px', background: `radial-gradient(circle, ${g.c}, ${g.c.replace(/[\d.]+\)$/, '0)')} 70%)`, filter: 'blur(78px)' }} />
                ))}
            </div>

            <div className="lp-sec-head">
                <div>
                    <div className="lp-quotes-eyebrow" data-lp-reveal>What they say.</div>
                    <h2 className="lp-h2" data-lp-reveal>Trusted by accountants across the UK.</h2>
                    <p className="lp-quotes-sub" data-lp-reveal>Here’s what accountants and their clients say about working with Diligentsia.</p>
                </div>
                <div className="lp-arrows">
                    <button className="lp-arrow" aria-label="Previous quotes" onClick={prev}><ChevronL /></button>
                    <button className="lp-arrow" aria-label="Next quotes" onClick={next}><ChevronR /></button>
                </div>
            </div>

            <div className="lp-viewport" onMouseEnter={pause} onMouseLeave={resume}>
                <div className="lp-vp-inner" ref={viewportRef}>
                    <div className="lp-slide-anim">
                        <div className="lp-track" ref={trackRef}>
                            {QUOTES.map((item, i) => (
                                <figure className="lp-qcard" key={i} data-lp-reveal data-lp-delay={(i % 3) * 120}>
                                    <div className="mark">“</div>
                                    <blockquote>{item.q}</blockquote>
                                    <figcaption>{item.a}</figcaption>
                                </figure>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            <div className="lp-foot">
                <p data-lp-reveal>Real feedback from accountants and their clients using Diligentsia.</p>
                <div className="lp-dots" style={{ margin: 0, padding: 0 }}>
                    {Array.from({ length: pages }).map((_, i) => (
                        <button key={i} className={`lp-dot ${i === page ? 'is-active' : ''}`} aria-label={`Go to slide ${i + 1}`} onClick={() => goTo(i)} />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default AccountantsQuotesSection;
